import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=d53fb328&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=d53fb328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53fb328",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d53fb328')) {
      api.createRecord('d53fb328', component.options)
    } else {
      api.reload('d53fb328', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=d53fb328&scoped=true&", function () {
      api.rerender('d53fb328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25GY8LcGpjZxq/JS/comp/GuestBox.vue"
export default component.exports